/* ─────────────────────────────────────────────────────────────
   Guardados (saved items)

   Flujo:
     · guardar es inmediato, sin pedir nada
     · si NO hay sesion, aparece un aviso con "Sign in to keep your list"
       que abre el LOGIN NATIVO de Shopify (cuentas nuevas, sin contraseña)
       en una ventana emergente; si el navegador la bloquea, redirige
     · al volver con sesion iniciada, el email del cliente se suscribe a la
       lista de Klaviyo (una sola vez) con el origen "Saved items"
     · cada guardado manda el evento "Saved Item" a Klaviyo

   Config: window.PDSavedConfig (se inyecta desde layout/theme.liquid)
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var CFG = window.PDSavedConfig || {};
  // Quien ha iniciado sesion DE VERDAD, segun la Customer Account API.
  // No confundir con `CFG.customerEmail`, que es la sesion de la tienda y puede
  // ser otra persona o no existir. Lo rellena pull().
  var account = null;
  var KEY = 'pd_saved_v1';
  var SUB_KEY = 'pd_saved_subscribed';

  /* ── almacen ─────────────────────────────────────────────── */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    paint();
    paintCount();
    document.dispatchEvent(new CustomEvent('pd:saved:change', { detail: { items: list } }));
  }
  function loggedIn() {
    return !!(CFG.customerEmail && CFG.customerEmail.indexOf('@') > -1);
  }

  // Lista que vive en la ficha del cliente. La escribe la extension del perfil;
  // aqui solo se lee. Es lo que hace que lo guardado en el movil aparezca en el
  // ordenador.
  function fromAccount() {
    var raw = CFG.savedFromAccount;
    if (!raw) return [];
    try {
      var list = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(list) ? list.filter(function (x) { return x && x.k; }) : [];
    } catch (e) {
      return [];
    }
  }

  // Lo de la ficha manda, pero no se pierde nada de este navegador.
  function mergeAccount() {
    var remote = fromAccount();
    if (!remote.length) return;
    var local = read();
    var seen = {};
    var out = [];
    remote.concat(local).forEach(function (it) {
      var k = String(it.k);
      if (seen[k]) return;
      seen[k] = true;
      out.push(it);
    });
    if (out.length !== local.length) write(out);
  }

  // Lo guardado aqui que la ficha del cliente todavia no tiene.
  function pending() {
    var remote = {};
    fromAccount().forEach(function (it) { remote[String(it.k)] = true; });
    return read().filter(function (it) { return !remote[String(it.k)]; });
  }

  // Enlace de traspaso a la seccion Saved del perfil.
  function handoffUrl() {
    var base = CFG.accountSavedUrl || '';
    if (!base) return '';
    var list = pending();
    if (!list.length) return base;
    var payload = '';
    try {
      payload = btoa(unescape(encodeURIComponent(JSON.stringify(list.slice(0, 60)))))
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
    } catch (e) {
      return base;
    }
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'add=' + payload;
  }

  /* ── Ficha del cliente (Customer Account API) ─────────────
     Aqui es donde lo guardado deja de vivir solo en el navegador y pasa a la
     cuenta del cliente, que es lo que lee la seccion Bookmarks del perfil.

     Cliente PUBLICO con PKCE del canal Headless: no hay servidor ni secreto.
     El permiso es del propio cliente y solo alcanza a SU ficha.

     La primera vez que se guarda en un equipo se abre una ventanita con el
     acceso de Shopify. Si ya hay sesion, se cierra sola en un parpadeo. A
     partir de ahi el permiso queda en el equipo y todo es silencioso.
     ───────────────────────────────────────────────────────── */
  var TOK_KEY = 'pd_ca_tok_v1';
  var CID_KEY = 'pd_ca_cid_v1';
  // momento del ultimo repaso correcto con la ficha del cliente
  var SYNC_KEY = 'pd_ca_sync_v1';
  // pieza guardada "a la espera" de que la persona complete el acceso
  var PROV_KEY = 'pd_saved_prov_v1';
  var PKCE_PREFIX = 'pd_ca_pkce_';
  var POPUP_NAME = 'pd-account';
  var SCOPES = 'openid email customer-account-api:full';

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  function caReady() {
    return !!(
      CFG.caClientId && CFG.caAuthorizeUrl && CFG.caTokenUrl && CFG.caApiUrl && CFG.caRedirectUri &&
      window.crypto && window.crypto.subtle && window.TextEncoder
    );
  }

  function tok() {
    try {
      var t = JSON.parse(ls(TOK_KEY) || 'null');
      return t && t.a ? t : null;
    } catch (e) {
      return null;
    }
  }
  function saveTok(json) {
    if (!json || !json.access_token) return null;
    var prev = tok() || {};
    var t = {
      a: json.access_token,
      r: json.refresh_token || prev.r || '',
      e: Date.now() + (Number(json.expires_in) || 3600) * 1000
    };
    lsSet(TOK_KEY, JSON.stringify(t));
    return t;
  }
  // ¿este equipo ya tiene permiso?
  function linked() { return !!tok(); }

  /* ── PKCE ── */
  function rand(n) {
    var a = new Uint8Array(n);
    window.crypto.getRandomValues(a);
    return Array.prototype.map
      .call(a, function (x) { return ('0' + x.toString(16)).slice(-2); })
      .join('');
  }
  function b64url(buf) {
    var bin = String.fromCharCode.apply(null, new Uint8Array(buf));
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function challenge(verifier) {
    return window.crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(verifier))
      .then(b64url);
  }

  function form(obj) {
    return Object.keys(obj)
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]); })
      .join('&');
  }
  function postToken(body) {
    return fetch(CFG.caTokenUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: form(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('token ' + r.status);
      return r.json();
    });
  }

  // Token vigente, refrescandolo si hace falta. Nunca abre una ventana.
  function token() {
    if (!caReady()) return Promise.resolve('');
    var t = tok();
    if (t && t.e > Date.now() + 60000) return Promise.resolve(t.a);
    if (t && t.r) {
      return postToken({
        grant_type: 'refresh_token',
        client_id: CFG.caClientId,
        refresh_token: t.r
      })
        .then(function (j) {
          var n = saveTok(j);
          return n ? n.a : '';
        })
        .catch(function () {
          lsDel(TOK_KEY);
          lsDel(CID_KEY);
          return '';
        });
    }
    return Promise.resolve('');
  }

  /* ── Pedir el permiso ── */
  /* El acceso de Shopify NO se puede meter en un iframe: la propia pagina manda
     `X-Frame-Options: DENY` y `frame-ancestors 'none'`. Asi que el aviso que se
     ve en la pagina es NUESTRO, y al aceptar se va al acceso de Shopify en la
     MISMA pestaña; al volver, se le deja donde estaba. Nada de ventanas nuevas. */
  function authorize(destino) {
    if (!caReady()) return;
    var state = rand(12);
    var verifier = rand(48);
    // se guarda de donde viene para devolverle a su sitio al volver. El icono de
    // la cabecera pasa `destino` porque ahi no se vuelve al sitio de origen: se
    // entra a los guardados, que es lo que la persona ha pedido.
    lsSet(PKCE_PREFIX + state, JSON.stringify({ v: verifier, t: Date.now(), r: destino || location.href }));
    challenge(verifier)
      .then(function (ch) {
        var url =
          CFG.caAuthorizeUrl +
          '?client_id=' + encodeURIComponent(CFG.caClientId) +
          '&response_type=code' +
          '&redirect_uri=' + encodeURIComponent(CFG.caRedirectUri) +
          '&scope=' + encodeURIComponent(SCOPES) +
          '&state=' + state +
          '&code_challenge=' + ch +
          '&code_challenge_method=S256';
        location.href = url;
      })
      .catch(function () {});
  }

  // La vuelta cae en /pages/saved con ?code=. Si esto es la ventanita, se
  // canjea aqui y se cierra: el token vive en localStorage, que las dos
  // ventanas comparten por ser el mismo dominio.
  function handleCallback() {
    if (location.search.indexOf('code=') === -1) return false;
    var isPopup = window.name === POPUP_NAME && !!window.opener;
    var params;
    try {
      params = new URLSearchParams(location.search);
    } catch (e) {
      return false;
    }
    var code = params.get('code');
    var state = params.get('state') || '';
    if (!code) return false;

    var verifier = '';
    var back = '';
    try {
      var rec = JSON.parse(ls(PKCE_PREFIX + state) || 'null') || {};
      verifier = rec.v || '';
      back = rec.r || '';
    } catch (e) {}
    lsDel(PKCE_PREFIX + state);
    if (!verifier) return false; // no es nuestro, que siga la pagina

    var done = postToken({
      grant_type: 'authorization_code',
      client_id: CFG.caClientId,
      redirect_uri: CFG.caRedirectUri,
      code: code,
      code_verifier: verifier
    })
      .then(function (j) {
        saveTok(j);
        lsDel(PROV_KEY); // completo el acceso: la pieza se queda
      })
      .catch(function (e) {
        if (window.console) console.warn('[pd-saved] no se pudo canjear el acceso', e);
      });

    if (isPopup) {
      done.then(function () {
        try { window.opener.postMessage({ pdca: 'ok' }, location.origin); } catch (e) {}
        window.close();
      });
      return true; // esta ventana no pinta nada mas
    }

    // Misma pestaña: se sube lo pendiente y se le devuelve a donde estaba.
    done.then(function () {
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      return pull();
    }).then(function () {
      if (back && back.indexOf(location.origin) === 0 && back.indexOf('code=') === -1) {
        // si ya se esta en ese sitio, no se recarga por gusto
        var ruta = back.slice(location.origin.length).split('?')[0].replace(/\/+$/, '');
        var aqui = location.pathname.replace(/\/+$/, '');
        if (ruta !== aqui) location.replace(back);
      }
    });
    return false;
  }

  /* ── Leer y escribir la ficha ── */
  function caQuery(query, variables) {
    return token().then(function (t) {
      if (!t) return null;
      return fetch(CFG.caApiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: t },
        body: JSON.stringify(variables ? { query: query, variables: variables } : { query: query })
      })
        .then(function (r) {
          if (r.status === 401 || r.status === 403) {
            lsDel(TOK_KEY);
            lsDel(CID_KEY);
            return null;
          }
          return r.json();
        })
        .then(function (j) {
          if (!j) return null;
          if (j.errors && j.errors.length) throw new Error(j.errors[0].message || 'error de la API');
          return j.data;
        });
    });
  }

  function customerId() {
    var cached = ls(CID_KEY);
    if (cached) return Promise.resolve(cached);
    return caQuery('{ customer { id } }').then(function (d) {
      var id = d && d.customer && d.customer.id;
      if (id) lsSet(CID_KEY, id);
      return id || '';
    });
  }

  var pushTimer = null;
  // Repaso de esta carga de pagina: hasta que no sepamos que hay en la ficha,
  // no se sube nada. Ver el porque en push().
  var pulled = null;

  /* Sube la lista de este equipo a la ficha del cliente.

     Dos candados, los dos por lo mismo: **subir pisa lo que haya en la ficha**,
     asi que solo se sube cuando sabemos que la copia de este equipo esta al dia.

     1. `allowEmpty` solo lo pone quien QUITA una pieza a mano. Sin eso, una
        lista vacia no se sube nunca.
     2. Se espera al repaso de esta carga y, **si ese repaso fallo, no se sube**.
        Si no, un fallo pasajero de la API deja la copia local vieja y el
        siguiente guardado la subiria entera, borrando de la ficha lo que este
        equipo no tenia. */
  function push(allowEmpty) {
    if (!caReady() || !linked()) return;
    if (!allowEmpty && !read().length) return;
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      (pulled || Promise.resolve(true)).then(function (ok) {
        if (ok === false) {
          if (window.console) console.warn('[pd-saved] repaso fallido: no se sube nada');
          return;
        }
        doPush(allowEmpty);
      });
    }, 500);
  }

  function doPush() {
    var list = read().slice(0, 250);
    customerId()
      .then(function (id) {
        if (!id) return null;
        return caQuery(
          'mutation S($m:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$m){ userErrors{ message } } }',
          {
            m: [{
              ownerId: id,
              namespace: 'custom',
              key: 'saved_items',
              type: 'json',
              value: JSON.stringify(list)
            }]
          }
        );
      })
      .then(function (r) {
        // Solo cuenta como repaso si de verdad se guardo: de lo contrario, en
        // el proximo repaso la ficha borraria lo que no llego a subir.
        if (r) lsSet(SYNC_KEY, String(Date.now()));
      })
      .catch(function (e) {
        if (window.console) console.warn('[pd-saved] no se pudo guardar en la ficha', e);
      });
  }

  function keysOf(list) {
    return list
      .map(function (it) { return String(it.k); })
      .sort()
      .join(',');
  }

  /* Trae la lista de la ficha y la deja mandar.

     Esto es lo que hace que quitar una pieza desde Bookmarks tambien la
     desmarque en las parrillas. Antes se hacia la union de las dos listas, y
     por eso lo borrado en el perfil volvia a aparecer: el navegador lo
     resucitaba.

     Regla: **la ficha manda**. De este equipo solo sobrevive lo guardado
     DESPUES del ultimo repaso correcto, que es lo que aun no ha llegado a
     subir. La primera vez (sin repaso previo) si se hace union, para no perder
     lo que hubiera guardado antes de dar permiso. */
  function pull() {
    if (!caReady() || !linked()) return Promise.resolve(false);
    return caQuery(
      '{ customer { id emailAddress { emailAddress marketingState }' +
      ' metafield(namespace:"custom", key:"saved_items"){ value } } }'
    )
      .then(function (d) {
        var c = d && d.customer;
        if (!c) return false;
        lsSet(CID_KEY, c.id);

        /* QUIEN ES de verdad. Ojo: la sesion de la tienda (Liquid) y la del
           area de cuenta son INDEPENDIENTES. Quien entra por el acceso de los
           guardados puede no tener sesion en la tienda, o peor: Liquid puede
           estar enseñando OTRA cuenta de antes. Para Klaviyo manda esta, que es
           la que de verdad ha iniciado sesion. */
        account = {
          id: c.id,
          email: (c.emailAddress && c.emailAddress.emailAddress) || '',
          marketing: !!(c.emailAddress && c.emailAddress.marketingState === 'SUBSCRIBED')
        };

        // OJO: que no venga metacampo NO significa que la ficha este vacia.
        // Si se tratan igual, un fallo pasajero borra la lista del navegador y
        // desde ahi se propaga a la ficha. Sin dato = no se toca nada.
        var raw = c.metafield && typeof c.metafield.value === 'string' ? c.metafield.value : null;
        if (raw === null) {
          if (read().length) push();
          return true;
        }

        var remote = [];
        try {
          remote = JSON.parse(raw || '[]') || [];
        } catch (e) {
          return true; // dato ilegible: mejor no tocar nada
        }
        if (!Array.isArray(remote)) return true;
        remote = remote.filter(function (it) { return it && it.k; });

        var local = read();
        var last = Number(ls(SYNC_KEY) || 0);
        var have = {};
        remote.forEach(function (it) { have[String(it.k)] = true; });

        var keep = local.filter(function (it) {
          if (!it || !it.k || have[String(it.k)]) return false;
          return last ? Number(it.ts || 0) > last : true;
        });

        var out = keep.concat(remote).sort(function (a, b) {
          return (b.ts || 0) - (a.ts || 0);
        });

        lsSet(SYNC_KEY, String(Date.now()));
        if (keysOf(out) !== keysOf(local)) write(out);
        // si este equipo traia algo que la ficha no tenia, se sube
        if (keep.length) push();
        syncCustomer();
        return true;
      })
      .catch(function () { return false; });
  }

  /* ── variante vigente ────────────────────────────────────── */
  // En la ficha el color se cambia despues de pintar el boton, asi que la
  // variante se lee del formulario de compra en cada momento.
  function currentKey(btn) {
    if (!btn.hasAttribute('data-pd-dynamic')) return btn.getAttribute('data-pd-key');
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : btn.getAttribute('data-pd-key');
  }

  /* ── pintado ─────────────────────────────────────────────── */
  function paint(root) {
    var keys = {};
    read().forEach(function (it) {
      keys[String(it.k)] = true;
    });
    (root || document).querySelectorAll('[data-pd-save]').forEach(function (btn) {
      var on = !!keys[String(currentKey(btn))];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Saved' : 'Save');
      btn.setAttribute('title', on ? 'Saved' : 'Save');
      var label = btn.querySelector('[data-pd-save-label]');
      if (label) label.textContent = on ? 'Saved' : 'Save';
    });
  }

  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-pd-saved-count]').forEach(function (el) {
      el.textContent = n ? '(' + n + ')' : '';
      el.classList.toggle('is-visible', n > 0);
    });
  }

  /* ── Klaviyo ─────────────────────────────────────────────── */
  function companyId() {
    if (CFG.klaviyoCompanyId) return CFG.klaviyoCompanyId;
    var s = Array.prototype.slice.call(document.scripts).find(function (x) {
      return x.src && x.src.indexOf('static.klaviyo.com/onsite/js/') > -1;
    });
    if (!s) return '';
    try {
      var u = new URL(s.src);
      return u.searchParams.get('company_id') || u.pathname.split('/').filter(Boolean)[2] || '';
    } catch (e) {
      return '';
    }
  }

  function klaviyoPush(args) {
    window.klaviyo = window.klaviyo || [];
    try {
      window.klaviyo.push(args);
    } catch (e) {}
  }

  function trackSave(item) {
    klaviyoPush([
      'track',
      'Saved Item',
      {
        Product: item.t,
        Color: item.c,
        Handle: item.h,
        VariantId: String(item.k),
        Url: location.origin + item.u,
        SavedProductsCount: read().length
      }
    ]);
  }

  /* Suscripcion a la lista de Klaviyo.
     Se hace una sola vez por cliente; queda anotada en el navegador.
     Las propiedades que manda son PROPIAS (`Saved products...`): no se toca
     `Signup source` ni ningun campo estandar, que se los pisaria a quien ya
     estuviera suscrito por otra via. */
  function subscribe(email) {
    var cid = companyId();
    var listId = CFG.klaviyoListId || '';
    if (!cid || !listId || !email) return Promise.resolve(false);

    var saved = read();
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CFG.sourceName || 'Saved products',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Saved products': true,
                  'Saved products count': saved.length,
                  'Saved products list': saved.slice(0, 50).map(function (it) {
                    return it.t + (it.c ? ' — ' + it.c : '');
                  })
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cid), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.status === 202;
      })
      .catch(function () {
        return false;
      });
  }

  /* Con quien hablamos en Klaviyo.
     Manda SIEMPRE la cuenta que ha iniciado sesion por el acceso de guardados;
     la de la tienda (Liquid) solo como reserva, porque puede estar vacia o ser
     una cuenta anterior. Mandar la equivocada es peor que no mandar nada. */
  function marketingEmail() {
    if (account && account.email) return account.email;
    return loggedIn() ? CFG.customerEmail : '';
  }
  function marketingOk() {
    if (account) return account.marketing;
    return !!CFG.acceptsMarketing;
  }

  /* Marcar el perfil y, si procede, suscribirlo.

     Ojo con el orden de los candados, que aqui es facil hacer estropicios:
     · identificar el perfil se hace siempre (no suscribe a nada)
     · la marca `Saved products` SOLO si de verdad ha guardado algo; si no,
       cualquier cliente que navegue entraria en el segmento
     · la lista SOLO si ademas acepta marketing */
  function syncCustomer() {
    var email = marketingEmail();
    if (!email) return;
    var saved = read();

    klaviyoPush(['identify', { $email: email }]);
    if (!saved.length) return;

    klaviyoPush([
      'identify',
      {
        $email: email,
        'Saved products': true,
        'Saved products count': saved.length
      }
    ]);

    if (!marketingOk()) return;
    var done = '';
    try {
      done = localStorage.getItem(SUB_KEY) || '';
    } catch (e) {}
    if (done === email) return;
    subscribe(email).then(function (ok) {
      if (!ok) return;
      try {
        localStorage.setItem(SUB_KEY, email);
      } catch (e) {}
    });
  }

  /* ── Login nativo de Shopify ───────────────────────────────
     Reserva para navegadores donde la Customer Account API no esta disponible.
     Va en la MISMA pestaña: nada de ventanas nuevas. */
  function openLogin() {
    location.href = CFG.loginUrl || '/account/login';
  }

  /* ── Aviso flotante ──────────────────────────────────────── */
  var toastEl = null;
  var toastTimer = null;
  function toast(text, actionLabel, action) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pd-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    if (actionLabel) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = actionLabel;
      b.addEventListener('click', function () {
        hideToast();
        action();
      });
      toastEl.appendChild(b);
    }
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, actionLabel ? 7000 : 2600);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-open');
  }

  /* ── Guardar / quitar ────────────────────────────────────── */

  // Cual de las opciones del producto es el color. Los nombres cambian entre
  // fichas ("color", "Colour"), asi que se busca por nombre y, si no aparece,
  // se cae a la primera opcion.
  function optionIndex(data, words, fallback) {
    var names = (data.options || []).map(function (o) {
      return String((o && o.name) || o || '').toLowerCase();
    });
    for (var i = 0; i < names.length; i++) {
      for (var j = 0; j < words.length; j++) {
        if (names[i].indexOf(words[j]) > -1) return i;
      }
    }
    return fallback < names.length ? fallback : -1;
  }

  function enrich(key, handle) {
    if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data) return;
        var v = (data.variants || []).find(function (x) {
          return String(x.id) === String(key);
        });
        if (!v) return;
        var list = read();
        var it = list.find(function (x) {
          return String(x.k) === String(key);
        });
        if (!it) return;

        // Guardados es una lista de PRODUCTOS: producto y color, nada mas.
        var ci = optionIndex(data, ['color', 'colour'], 0);
        var opts = v.options || [];
        if (ci > -1 && opts[ci]) it.c = opts[ci];

        it.u = '/products/' + handle + '?variant=' + key;
        var src = (v.featured_image && v.featured_image.src) || data.featured_image || '';
        if (src) it.i = src.split('?')[0] + '?width=500';
        write(list);
        push();
      })
      .catch(function () {});
  }

  // ¿esta variante ya esta guardada?
  function isSaved(btn) {
    var key = String(currentKey(btn) || '');
    return read().some(function (it) { return String(it.k) === key; });
  }

  function toggle(btn) {
    var key = currentKey(btn);
    if (!key) return;
    var list = read();
    var idx = list.findIndex(function (it) {
      return String(it.k) === String(key);
    });

    if (idx > -1) {
      list.splice(idx, 1);
      write(list);
      push(true);
      return;
    }

    var dyn = btn.hasAttribute('data-pd-dynamic');
    var item = {
      k: key,
      h: btn.getAttribute('data-pd-handle') || '',
      t: btn.getAttribute('data-pd-title') || '',
      c: btn.getAttribute('data-pd-color') || '',
      u: btn.getAttribute('data-pd-url') || '',
      i: btn.getAttribute('data-pd-img') || '',
      ts: Date.now()
    };
    list.unshift(item);
    write(list);
    if (dyn) enrich(key, item.h);

    btn.classList.remove('is-popping');
    void btn.offsetWidth;
    btn.classList.add('is-popping');

    trackSave(item);
    var kmail = marketingEmail();
    if (kmail) {
      klaviyoPush([
        'identify',
        { $email: kmail, 'Saved products': true, 'Saved products count': list.length }
      ]);
    }

    /* A la ficha del cliente.
       · con permiso: se sube sin que se note
       · sin permiso: derecho al acceso de Shopify, EN LA MISMA PESTAÑA. Sin
         pasos intermedios y sin ventanas nuevas; al volver, se le deja en la
         pagina donde estaba y lo guardado sube solo. */
    if (!caReady()) {
      openLogin();
    } else if (linked()) {
      push();
    } else {
      // Queda A LA ESPERA: si no completa el acceso, se desmarca al volver.
      lsSet(PROV_KEY, String(key));
      authorize();
    }
  }

  /* ── Pagina Saved ────────────────────────────────────────── */
  function money(cents) {
    var fmt = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var noDec = Math.round(cents / 100).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function renderPage(root) {
    var list = read();
    var grid = root.querySelector('[data-pd-saved-grid]');
    var empty = root.querySelector('[data-pd-saved-empty]');
    var sub = root.querySelector('[data-pd-saved-sub]');
    if (!grid) return;

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (sub) sub.textContent = '';
      return;
    }
    if (empty) empty.hidden = true;
    if (sub) sub.textContent = list.length + (list.length === 1 ? ' item' : ' items');

    grid.innerHTML = list
      .map(function (it) {
        // Al carrito y te deja EN el carrito. Ojo: /cart/<id>:1 no vale, ese es
        // el enlace de checkout directo.
        var action = '/cart/add?id=' + encodeURIComponent(String(it.k)) + '&quantity=1';
        var actionLabel = 'Add to cart';
        return (
          '<article class="pd-saved-item" data-pd-saved-item="' +
          String(it.k).replace(/"/g, '') +
          '">' +
          '<div class="pd-saved-item__frame">' +
          '<a class="pd-saved-item__media" href="' + it.u + '">' +
          (it.i ? '<img src="' + it.i + '" alt="' + it.t.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="pd-saved-item__btn pd-saved-item__remove" data-pd-saved-remove aria-label="Remove" title="Remove">' +
          '<svg width="11" height="11" viewBox="0 0 11 11" aria-hidden="true" focusable="false"><path d="M1 1l9 9M10 1l-9 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<a class="pd-saved-item__btn pd-saved-item__cart" href="' + action + '" aria-label="' + actionLabel + '" title="' + actionLabel + '">' +
          '<svg width="14" height="15" viewBox="0 0 19 20" fill="none" aria-hidden="true" focusable="false"><path d="M1 4.58011L3.88304 1.09945V1H15.2164L18 4.58011M1 4.58011V17.2099C1 18.2044 1.89474 19 2.88889 19H16.1111C17.1053 19 18 18.2044 18 17.2099V4.58011M1 4.58011H18M13.3275 8.16022C13.3275 10.1492 11.6374 11.7403 9.54971 11.7403C7.46199 11.7403 5.67251 10.1492 5.67251 8.16022" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</a>' +
          '</div>' +
          '<a class="pd-saved-item__info" href="' + it.u + '">' +
          '<span class="pd-saved-item__title">' + it.t + '</span>' +
          (it.c ? '<span class="pd-saved-item__color">' + it.c + '</span>' : '') +
          '<span class="pd-saved-item__price" data-pd-saved-price></span>' +
          '</a>' +
          '</article>'
        );
      })
      .join('');

    var handles = {};
    list.forEach(function (it) {
      if (it.h) handles[it.h] = true;
    });
    Object.keys(handles).forEach(function (handle) {
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (!data || !data.variants) return;
          data.variants.forEach(function (v) {
            var node = grid.querySelector('[data-pd-saved-item="' + v.id + '"]');
            if (!node) return;
            var priceEl = node.querySelector('[data-pd-saved-price]');
            if (!priceEl) return;
            priceEl.textContent = money(v.price) + (v.available ? '' : ' · Sold out');
            if (!v.available) node.classList.add('pd-saved-item__sold');
          });
        })
        .catch(function () {});
    });
  }

  function paintHandoff(root) {
    var slot = root.querySelector('[data-pd-saved-sync]');
    if (!slot) return;
    slot.innerHTML = '';
    // Con la Customer Account API el traspaso es automatico, asi que no se
    // enseña ningun enlace de importar. Este resto solo actua si esa via no
    // esta disponible en el navegador.
    if (caReady()) return;
    var n = pending().length;
    var url = handoffUrl();
    if (!n || !url) return;
    var a = document.createElement('a');
    a.className = 'pd-saved-sync';
    a.href = url;
    a.textContent =
      n === 1 ? 'Add 1 item to your account' : 'Add ' + n + ' items to your account';
    a.setAttribute('rel', 'nofollow');
    slot.appendChild(a);
  }

  function initPage() {
    var root = document.querySelector('[data-pd-saved-page]');
    if (!root) return;
    renderPage(root);
    paintHandoff(root);
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pd-saved-remove]');
      if (!rm) return;
      e.preventDefault();
      var item = rm.closest('[data-pd-saved-item]');
      if (!item) return;
      var key = item.getAttribute('data-pd-saved-item');
      write(
        read().filter(function (it) {
          return String(it.k) !== String(key);
        })
      );
      push(true);
      renderPage(root);
    });
    document.addEventListener('pd:saved:change', function () {
      renderPage(root);
      paintHandoff(root);
    });
  }

  /* ── Arranque ────────────────────────────────────────────── */
  function init() {
    // Si esto es la ventanita del acceso, canjea y se cierra. No pinta nada.
    if (handleCallback()) return;

    /* Guardar sin sesion deja la pieza "a la espera". Si la persona se salta el
       acceso, no puede quedarse marcada: se quita aqui. En la vuelta del acceso
       (la url trae ?code=) no se toca nada, que el permiso aun se esta
       canjeando. */
    var prov = ls(PROV_KEY);
    if (prov && location.search.indexOf('code=') === -1) {
      lsDel(PROV_KEY);
      if (!linked()) {
        write(read().filter(function (it) { return String(it.k) !== prov; }));
      }
    }

    mergeAccount();
    paint();
    paintCount();
    initPage();
    // Si hay permiso, el repaso es quien llama a syncCustomer(), ya con el email
    // de verdad. Sin permiso solo queda la sesion de la tienda.
    if (!linked()) syncCustomer();

    // Al volver de la ventanita ya hay permiso: se sincroniza.
    window.addEventListener('message', function (e) {
      if (e.origin !== location.origin) return;
      if (!e.data || e.data.pdca !== 'ok') return;
      pulled = pull();
    });

    // Repaso con la ficha en CADA carga: si se quita una pieza desde Bookmarks,
    // el icono de las parrillas tiene que dejar de estar marcado enseguida.
    if (linked()) pulled = pull();
    // Volver con la flecha del navegador no recarga la pagina (bfcache).
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && linked()) pulled = pull();
    });

    document.addEventListener('click', function (e) {
      // Icono de guardados de la cabecera: sin sesion se pide acceso ANTES de
      // entrar, igual que hace el bookmark de una tarjeta. Si el navegador no
      // puede con el acceso, el enlace funciona como un enlace normal.
      var aGuardados = e.target.closest('[data-pd-saved-link]');
      if (aGuardados) {
        if (!linked() && caReady()) {
          e.preventDefault();
          authorize(aGuardados.href);
        }
        return;
      }
      var btn = e.target.closest('[data-pd-save]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn);
    });

    // al cambiar de color/talla en la ficha, el boton refleja si ESA variante
    // esta guardada
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(function () {
          paint();
        }, 90);
      }
    });

    // las parrillas cargan tarjetas por AJAX (scroll infinito, filtros)
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () {
          paint();
        }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PDSaved = {
    all: read,
    count: function () {
      return read().length;
    },
    login: openLogin,
    repaint: paint,
    // cuenta del cliente (para comprobaciones)
    linked: linked,
    connect: authorize,
    pull: pull,
    push: push
  };
})();
